import "./LoginModal.scss";
import React, { ChangeEvent, useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { IoCloseCircle, IoEye, IoEyeOff } from "react-icons/io5";
import RestClient from "../../../../@core/restClient";
import { jwtDecode } from "jwt-decode";
import Spinner from "../../../widgets/UI/Spinner";

interface LoginData {
  email: string;
  password: string;
}

type LoginDataState = [
  loginData: LoginData,
  setLoginData: (loginData: LoginData) => void
];
const LoginModal = () => {
  const [loginData, setLoginData]: LoginDataState = useState({
    email: "",
    password: ""
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [registrationData, setRegistrationData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: ""
  });
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [type, setType] = useState(["password", "password"]);
  const [eye, setEye] = useState(["off", "off"]);
  const [isLoading, setIsLoading] = useState(false);
  const [policyCheck, setPolicyCheck] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [codeCheck, setCodeCheck] = useState(false);
  const [codeData, setCodeData] = useState({
    email: "",
    confirmationCode: ""
  });
  const [forgotPassordModal, setForgotPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({ email: "" });
  const navigate = useNavigate();

  // OPEN REGISTRATION WINDOW
  const isModalOpen = searchParams.get("registration") === "true";
  const openRegistrationModal = () => {
    setSearchParams({ registration: "true" });
  };
  const closeRegistrationModal = () => {
    //setSearchParams({});
    navigate(-1);
    setRegistrationData({
      email: "",
      password: "",
      firstName: "",
      lastName: ""
    });
  };

  //SHOW PASSWORD IN INPUT
  const toggleEye = (i: any) => {
    const types = [...type];
    if (types[i] === "password") {
      types[i] = "text";
    } else {
      types[i] = "password";
    }
    setType(types);

    const eyes = [...eye];
    if (eyes[i] === "off") {
      eyes[i] = "on";
    } else {
      eyes[i] = "off";
    }
    setEye(eyes);
  };
  // ENABLE REGISTRATION BUTTON

  const enable = (e: any) => {
    if (e.target.checked) {
      setPolicyCheck(true);
    } else {
      setPolicyCheck(false);
    }
  };
  useEffect(() => {
    if (
      policyCheck &&
      registrationData.email !== "" &&
      registrationData.password !== "" &&
      registrationData.firstName !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [policyCheck, registrationData]);

  //LOGI DATA
  const login = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.login(loginData);
      localStorage.setItem("Token", response.token);
      const decodedToken: any = jwtDecode(response.token);
      localStorage.setItem("User", JSON.stringify(decodedToken));
      navigate(-1);
    } catch (error: any) {
      console.log(error.response.data.message);
      setErrorMessage("Непривийльний email або пароль");
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  //SEND REGISTRATION DATA

  const register = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.register(registrationData);
      if (response?.status === "pending") {
        setCodeCheck(true);
      } else {
        throw "Incorrect response";
      }
    } catch (error: any) {
      console.log(error.response.data.message);
      if (error.response.data.message === "User already exists") {
        setErrorMessage("Користувач з такою адресою вже існує");
      } else {
        setErrorMessage("Щось пішло не так, спробуйте ще раз");
      }
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  const completeRegister = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.confirmRegistration(codeData);
      if (response?.token) {
        localStorage.setItem("Token", response.token);
        const decodedToken: any = jwtDecode(response.token);
        localStorage.setItem("User", JSON.stringify(decodedToken));
        closeRegistrationModal();
        setCodeCheck(false);
        navigate("/");
      } else {
        throw "Incorrect response";
      }
    } catch (error: any) {
      console.log(error.response.data.message);
      if (error.response.data.message === "Incorrect Confirmation Code") {
        setErrorMessage("Ви ввели неправильний код, спробуйте ще раз");
      } else {
        setErrorMessage("Щось пішло не так, спробуйте ще раз");
      }
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  // RENEWING PASSWORD

  const sendForgotPassword = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.resetPassword(passwordData);
      if (response?.status === "completed") {
        setErrorMessage(
          "Вам на пошту було надіслано новий пароль. Старий пароль більше не дійсний. Ви можете зайти у кабінет і замінити новий пароль на інший. Якщо лист з паролем не надійшов на пошту, спробуйте ще раз або зверніться у підтримку "
        );
        setForgotPasswordModal(false);
        setErrorModal(true);
      }
    } catch (error: any) {
      console.log(error.response.data.message);
      setErrorMessage("Щось пішло не так, спробуйте ще раз");
      setErrorModal(true);
    }
    setIsLoading(false);
  };

  return (
    <div className="login-modal">
      {isLoading ? <Spinner /> : ""}
      {!isModalOpen ? (
        <div className="login-modal-box">
          <div className="login-input">
            <div className="login-input-item">
              <label>Email</label>
              <input
                type="text"
                placeholder="Введіть email"
                value={loginData.email}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setLoginData({ ...loginData, email: event.target.value })
                }
              />
            </div>
            <div className="login-input-item">
              <label>Пароль</label>
              <input
                type={type[0]}
                placeholder="Введіть пароль"
                value={loginData.password}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setLoginData({ ...loginData, password: event.target.value })
                }
              />
              <div className="login-input-item-eye">
                {type[0] === "password" ? (
                  <IoEye onClick={() => toggleEye(0)} />
                ) : (
                  <IoEyeOff onClick={() => toggleEye(0)} />
                )}
              </div>
            </div>
          </div>
          <div className="btn-box">
            <button className="btn-mcolor btn-box-btn" onClick={login}>
              Увійти
            </button>
            <button
              className="btn-forget-password"
              onClick={() => {
                setForgotPasswordModal(true);
              }}
            >
              Забули пароль?
            </button>
          </div>
          <div className="invite">
            <p className="invite-text">
              Якщо ви не зареєстровані, тисніть{" "}
              <button
                className="btn-plain invite-text-btn"
                onClick={openRegistrationModal}
              >
                Сюди
              </button>{" "}
            </p>
          </div>
          <IoCloseCircle className="closeIcon" onClick={() => navigate(-1)} />
          {forgotPassordModal ? (
            <div className="codecheck-box">
              <IoCloseCircle
                className="closeIcon"
                onClick={() => {
                  setForgotPasswordModal(false);
                  setPasswordData({ email: "" });
                }}
              />
              <div>
                <p className="codecheck-box-message">
                  Введіть свою електронну адресу для відновлення пароля:
                </p>
                <input
                  type="text"
                  className="login-input"
                  value={passwordData.email}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setPasswordData({
                      ...passwordData,
                      email: event.target.value
                    })
                  }
                />
              </div>
              <div>
                <button
                  className={
                    passwordData.email === ""
                      ? "btn-mcolor-inactive"
                      : "btn-mcolor"
                  }
                  disabled={passwordData.email === "" ? true : false}
                  onClick={sendForgotPassword}
                >
                  Відправити
                </button>
              </div>
            </div>
          ) : null}
          {errorModal ? (
            <div className="error-box">
              <p className="error-text">{errorMessage}</p>
              {/* <IoCloseCircle
                className="closeIcon"
                onClick={() => setErrorModal(false)}
              /> */}
              <div>
                <button
                  className="btn-mcolor"
                  onClick={() => setErrorModal(false)}
                >
                  Ok
                </button>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <div className="login-modal-box">
          <div className="login-input">
            <div className="login-input-item">
              <label>Ім&apos;я</label>
              <input
                type="text"
                //placeholder="Ім'я"
                value={registrationData.firstName}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegistrationData({
                    ...registrationData,
                    firstName: event.target.value
                  })
                }
              />
            </div>
            <div className="login-input-item">
              <label>Прізвище</label>
              <input
                type="text"
                //placeholder="Прізвище"
                value={registrationData.lastName}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegistrationData({
                    ...registrationData,
                    lastName: event.target.value
                  })
                }
              />
            </div>
          </div>

          <div className="login-input">
            <div className="login-input-item">
              <label>Email</label>
              <input
                type="text"
                //placeholder="Email"
                value={registrationData.email}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  setRegistrationData({
                    ...registrationData,
                    email: event.target.value
                  });
                  setCodeData({
                    ...codeData,
                    email: event.target.value
                  });
                }}
              />
            </div>
            <div className="login-input-item">
              <label>Пароль</label>
              <input
                type={type[1]}
                //placeholder="Пароль"
                value={registrationData.password}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegistrationData({
                    ...registrationData,
                    password: event.target.value
                  })
                }
              />
              <div className="login-input-item-eye">
                {type[1] === "password" ? (
                  <IoEye onClick={() => toggleEye(1)} />
                ) : (
                  <IoEyeOff onClick={() => toggleEye(1)} />
                )}
              </div>
            </div>
          </div>
          <div className="policy">
            <input type="checkbox" id="policy" onClick={(e) => enable(e)} />
            <label
              htmlFor="policy"
              onClick={() => navigate("/privacypolicyukr")}
            >
              З політикою конфіденційності сайту ознайомлений
            </label>
          </div>
          <div className="btn-box">
            <button
              className={
                disabled
                  ? "btn-mcolor-inactive btn-box-btn"
                  : "btn-mcolor btn-box-btn"
              }
              onClick={register}
              disabled={disabled}
            >
              Зареєструватись
            </button>
          </div>

          <IoCloseCircle
            className="closeIcon"
            onClick={closeRegistrationModal}
          />
          {codeCheck ? (
            <div className="codecheck-box">
              <div>
                <p className="codecheck-box-message">
                  Ми відправили вам на електронну пошту листа з кодом. Для
                  завершення реєстрації введіть цей код у поле знизу. Якщо ліст
                  не надійшов, перевірте адресу і почніть реєстрацію спочатку.
                </p>
                <input
                  type="text"
                  className="login-input"
                  value={codeData.confirmationCode}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setCodeData({
                      ...codeData,
                      confirmationCode: event.target.value
                    })
                  }
                />
              </div>
              <div>
                <button className="btn-mcolor" onClick={completeRegister}>
                  Відправити
                </button>
              </div>
            </div>
          ) : null}

          {errorModal ? (
            <div className="error-box">
              <p className="error-text">{errorMessage}</p>
              <IoCloseCircle
                className="closeIcon"
                onClick={() => {
                  setErrorModal(false);
                  navigate(-2);
                }}
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};
export default LoginModal;
